<template>
    <!-- Slider main container -->
    <div id="productsViewer">
        <template v-if="isLoading">
            <b-spinner label="Cargando..." variant="primary" class="my-2">
                <strong>Cargando...</strong>
            </b-spinner>
        </template>
        <template v-else>

            <!-- <b-tabs class="tabSelector mb-4" v-model="selectedTab"> -->
                <!-- <b-tab v-for="(tab, index) in tabOptions" :key="index" :title="tab" /> -->
            <!-- </b-tabs>  -->
            <!-- 
            -->
            <ui-tabs v-model="selectedTab" :options="tabOptions" auto-select-first disable-button-mode auto class="mb-4" />
            <!-- <ui-tabs v-model="selectedTab" :options="tabOptions" auto-select-first auto class="mb-4" /> -->
            <!-- {{ selectedTab }}  -->
            <!-- <code>{{ tabOptions }}</code> -->

            <b-jumbotron v-if="filteredOffers.length === 0" bg-variant="info" text-variant="white"
                class="text-center mt-5">
                <template #header>No hay ofertas disponibles</template>
                <p>Por favor, vuelva a intentarlo más tarde.</p>
            </b-jumbotron>

            <products-viewer-swiper :key="keyName" v-else v-model="selectedOfferId" :offers="filteredOffers" @click="clicked" />
            
            <div class="debug" v-if="debug">
                <div>{{ keyName }}</div>
                <div>{{ selectedTab }}</div>
                <div>{{ tabOptions }}</div>
            </div>

        </template>
    </div>
</template>

<script>
// import Swiper JS
// import Swiper from 'swiper';
// import 'swiper/css';
// import { Navigation, Pagination } from 'swiper/modules';

import _ from 'lodash'
import productsViewerSwiper from './products-viewer-swiper.vue';
import axios from 'axios'

import md5 from 'js-md5';

const TAB_SUSCRIPTION = 'Mensual',
    TAB_TRIMESTRAL = '3 meses',
    TAB_SEMESTRAL = '6 meses',
    TAB_ANUAL = '12 meses',
    TAB_TWO_YEARS = '24 meses',
    tabOptions = [
        TAB_SUSCRIPTION,
        TAB_TRIMESTRAL,
        TAB_SEMESTRAL,
        TAB_ANUAL,
        TAB_TWO_YEARS
    ];

export default {
    name: 'productsViewer',
    components: {
        productsViewerSwiper
    },
    props: {
        debug: {
            type: Boolean,
            default: false
        },
        value: {
            type: [String, Number]
        },
        loadUpURI: {
            type: String,
            default: 'ofertas/getactive'
        },
        tabOptions: {
            type: Array,
            default: () => tabOptions
        },
        onlyMifi: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isLoading: false,
            selectedTab: 0,
            stripePublicKey: null,
            swiperObj: null,
            offerOptions: [],
            selectedOfferId: null
        };
    },
    computed: {
        keyName(){
            return 'd-' + md5( '-' + this.tabOptions.indexOf(this.selectedTab));
        },
        suscriptionPrice() {
            let price = 0;
            try {
                const selected = _.find(this.offerOptions, { id: this.value });
                if (selected) {
                    price = selected.precio;
                }
            } catch (e) {
                console.error('suscriptionPrice', e)
            }
            return price;
        },
        filteredOffers() {
            switch (this.selectedTab) {
                case TAB_SUSCRIPTION:
                    return _.filter(this.offerOptions, offer => (offer.duracion_unidad === 'Meses' && (parseInt(offer.duracion) == 1)));
                case TAB_TRIMESTRAL:
                    return _.filter(this.offerOptions, { duracion_unidad: 'Meses', duracion: '3' });
                case TAB_SEMESTRAL:
                    return _.filter(this.offerOptions, { duracion_unidad: 'Meses', duracion: '6' });
                case TAB_ANUAL:
                    return _.filter(this.offerOptions, offer => offer.duracion_unidad === 'Meses' && parseInt(offer.duracion) == 12);
                case TAB_TWO_YEARS:
                    return _.filter(this.offerOptions, offer => offer.duracion_unidad === 'Meses' && parseInt(offer.duracion) == 24);
                default:
                    return this.offerOptions;
            }
        }
    },
    methods: {

        getSelectedPrice() {
            return this.suscriptionPrice;
        },

        getStripePublicKey() {
            return this.stripePublicKey;
        },

        clicked() {
            // alert('Clicked on offer: ' + this.selectedOfferId);
            if (this.value !== this.selectedOfferId) {
                this.$emit('input', this.selectedOfferId);  
            }
            this.$nextTick(() => {
                this.$emit('selectedOffer', this.getSelectedPrice());
                setTimeout(() => {
                    this.$emit('goNext');
                }, 100);
            });
        },

        async loadUp() {
            this.isLoading = true;
            try {
                // RESPONSE
                const response = await axios.get(this.loadUpURI + "/" + (this.onlyMifi ? 'MIFI' : 'MOBILE'));

                // GENERAL OBJECT LIKE
                if (!_.isObjectLike(response))
                    throw 'Error de server';

                if (!response.status)
                    throw response.msg;

                this.offerOptions = response.data;
                this.stripePublicKey = response.stripePublicKey;
            } catch (error) {
                console.error('Error loading catalog:', error);
            }
            this.isLoading = false;
        }
    },
    mounted() {
        this.loadUp()
    },
    created() {
        this.selectedOfferId = _.clone(this.value);
    },
    // watch: {
    //     selectedOfferId(newValue) {
            
    //     }
    // }
}
</script>

<style lang="scss">
#productsViewer {
    min-height: 60vh;

    .tabSelector {
        .nav {
            justify-content: center;
        }
    }
}
</style>